import axios from "axios";
import { API_CLIENT_ID, API_CLIENT_SECRET, AUTH_KEY, BASE_API_URL, ROUTES } from "./constants";
const instance = axios.create({
    baseURL: BASE_API_URL,
    headers: {
        "Content-Type": "application/json",
        'X-Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone
    },
});
instance.interceptors.request.use(
    (config) => {
        if (localStorage.getItem(AUTH_KEY)) {
            const auth = JSON.parse(localStorage.getItem(AUTH_KEY));
            const { access_token } = auth;
            config.headers["Authorization"] = 'Bearer ' + access_token;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
instance.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;
        if(error.response?.status === 401 && !originalRequest.url.includes("/oauth/token")){
            const auth = JSON.parse(localStorage.getItem("auth"));
            try {
                
                const res = await axios.post(`${process.env.REACT_APP_API}oauth/token`, {
                    grant_type: "refresh_token",
                    client_id: API_CLIENT_ID,
                    client_secret: API_CLIENT_SECRET,
                    refresh_token: auth?.refresh_token,
                    scope: ""
                });
                localStorage.setItem(AUTH_KEY, JSON.stringify(res.data));
                instance.defaults.headers.common["Authorization"] = "Bearer " + res.data.access_token;
                return instance(originalRequest);
            } catch (err) {
                console.log(err)
                localStorage.removeItem(AUTH_KEY);
                window.location.href = ROUTES.AUTH_ROUTE;
            } 
            
        }
        return Promise.reject(error);
    }
);
export default instance;